import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// IMDG CODE(海运危险货物规则)

// 导出订单
export function exportOrder(params) {
  return request({
    url: URL.systemDocking.kef.exportOrder,
    method: 'get',
    responseType: 'blob',
    params
  })
}
// 导出订单统计
export function exportOrderCount(params) {
  return request({
    url: URL.systemDocking.kef.exportOrderCount,
    method: 'get',
    params
  })
}
// 导出账单
export function exportBill(params) {
  return request({
    url: URL.systemDocking.kef.exportBill,
    method: 'get',
    responseType: 'blob',
    params
  })
}
// 导出账单
export function importBill(type) {
  return request({
    url: `${URL.systemDocking.kef.importBill}?lob=${type}`,
    method: 'post'
  })
}
// 导出账单
export function getFileId(fileFlagNo) {
  return request({
    url: `${URL.systemDocking.kef.getFileId}?fileFlagNo=${fileFlagNo}`,
    method: 'get'
  })
}
